var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "p",
    { staticClass: "ml-1 text-sm text-red-600" },
    [
      _vm._t("default", function () {
        return [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }